import React from 'react'

const HomePage = React.lazy(() => import('src/pages/HomePage'))
const Feedback = React.lazy(() => import('src/pages/Feedback'))
const ContactUs = React.lazy(() => import('src/pages/ContactUs'))
const PrivacyPolicy = React.lazy(() => import('src/pages/PrivacyPolicy'))
const FinishedAssessments = React.lazy(() => import('src/pages/FinishedAssessments'))
const About = React.lazy(() => import('src/pages/About'))
const Posts = React.lazy(() => import('src/pages/Posts'))
const SampleAssessment = React.lazy(() => import('src/pages/SampleAssessment'))
const VideoAndMemoIntroductions = React.lazy(() => import('src/pages/VideoAndMemoIntroductions'))
const StartAssessment = React.lazy(() => import('src/pages/StartAssessment'))
const Conclusion = React.lazy(() => import('src/pages/Conclusion'))
const AssessmentGroup = React.lazy(() => import('src/pages/AssessmentGroup'))
const ProfessionalInfo = React.lazy(() => import('src/pages/ProfessionalInfo'))
const Report = React.lazy(() => import('src/pages/Report'))
const HighestScoringByJurisdiction = React.lazy(
  () => import('src/pages/HighestScoringByJurisdiction'),
)
const HighestScoringByStates = React.lazy(() => import('src/pages/HighestScoringByStates'))
const AssessmentByState = React.lazy(() => import('src/pages/AssessmentByState'))
const AssessmentByJurisdiction = React.lazy(() => import('src/pages/AssessmentByJurisdiction'))
const ReportsFromCounties = React.lazy(() => import('src/pages/ReportsFromCounties'))
const CompareJurisdictions = React.lazy(() => import('src/pages/CompareJurisdictions'))
const RecentImprovements = React.lazy(() => import('src/pages/RecentImprovements'))
const RetrieveAssessments = React.lazy(() => import('src/pages/RetrieveAssessments'))
const FeedbackResponse = React.lazy(() => import('src/pages/FeedbackResponse'))
const homeRoutes = [
  { path: '/', exact: true, name: 'Home', element: HomePage },
  { path: '/feedback', exact: true, name: 'Feedback', element: Feedback },
  { path: '/feedbackresponse', exact: true, name: 'FeedbackResponse', element: FeedbackResponse },
  { path: '/contactus', exact: true, name: 'ContactUs', element: ContactUs },
  { path: '/privacy', exact: true, name: 'PrivacyPolicy', element: PrivacyPolicy },
  {
    path: '/seefinishedassessments',
    exact: true,
    name: 'FinishedAssessments',
    element: FinishedAssessments,
  },
  { path: '/about', exact: true, name: 'About', element: About },
  { path: '/importantposts', exact: true, name: 'Posts', element: Posts },
  { path: '/sampleassessment', exact: true, name: 'SampleAssessment', element: SampleAssessment },
  {
    path: '/videoandmemo',
    exact: true,
    name: 'VideoAndMemoIntroductions',
    element: VideoAndMemoIntroductions,
  },
  {
    path: '/startassessment',
    exact: true,
    name: 'StartAssessment',
    element: StartAssessment,
  },

  { path: '/report/:id', exact: true, name: 'Report', element: Report },
  {
    path: '/highestscoringbyjurisdiction',
    exact: true,
    name: 'HighestScoringByJurisdiction',
    element: HighestScoringByJurisdiction,
  },
  {
    path: '/highestscoringbystates',
    exact: true,
    name: 'HighestScoringByStates',
    element: HighestScoringByStates,
  },
  {
    path: '/assessmentsbystate',
    exact: true,
    name: 'AssessmentsByState',
    element: AssessmentByState,
  },
  {
    path: '/assessmentsbyjurisdiction',
    exact: true,
    name: 'AssessmentByJurisdiction',
    element: AssessmentByJurisdiction,
  },
  {
    path: '/assessmentsbyjurisdiction/reports',
    exact: true,
    name: 'ReportsFromCounties',
    element: ReportsFromCounties,
  },
  {
    path: '/comparejurisdictions',
    exact: true,
    name: 'CompareJurisdictions',
    element: CompareJurisdictions,
  },
  {
    path: '/recentimprovements',
    exact: true,
    name: 'RecentImprovements',
    element: RecentImprovements,
  },
  {
    path: '/retrieveyourassessments',
    exact: true,
    name: 'RetrieveAssessments',
    element: RetrieveAssessments,
  },
]

const SurveyRoutes = [
  {
    path: '/group/:id',
    exact: true,
    name: 'AssessmentGroup',
    element: AssessmentGroup,
  },
  {
    path: '/conclusion',
    exact: true,
    name: 'Conclusion',
    element: Conclusion,
  },

  {
    path: '/professionalinfo',
    exact: true,
    name: 'ProfessionalInfo',
    element: ProfessionalInfo,
  },
  {
    path: '/report',
    exact: true,
    name: 'Report',
    element: Report,
  },
]

export { homeRoutes, SurveyRoutes }
